export const GANTT_ROW_HEIGHT = 69;
export const GANTT_ROW_HEIGHT_MINI = 45;
export const DEFAULT_TABLE_COLUMN_SIZE = 150;

export const GANTT_HEADER_HEIGHT = 30;

export const GANTT_HEADER_ID = "react-table-gantt-header";
export const GANTT_BODY_ID = "react-table-gantt-body";
export const GANTT_COMMON_TABLE_HEADER_ID = "react-table-common-gantt-header";
export const GANTT_COMMON_TABLE_BODY_ID = "react-table-common-gantt-body";
export const GANTT_LEFT_SHIFT = 1;
export const GANTT_TOP_SHIFT = 4;

export const GANTT_COLUMN_WIDTH_MONTH = 54;
export const GANTT_COLUMN_WIDTH_YEAR = 230;
export const GANTT_COLUMN_WIDTH_QUARTER = 54;
export const GANTT_COLUMN_WIDTH_WEEK = 100;
